'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _nitroRadio = require('../nitro-radio');

var _nitroRadio2 = _interopRequireDefault(_nitroRadio);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NitroRadioGroup = function (_Component) {
  _inherits(NitroRadioGroup, _Component);

  function NitroRadioGroup(props) {
    _classCallCheck(this, NitroRadioGroup);

    var _this = _possibleConstructorReturn(this, (NitroRadioGroup.__proto__ || Object.getPrototypeOf(NitroRadioGroup)).call(this, props));

    _this.get = function () {
      return _this.state.selected;
    };

    _this.clear = function () {
      _this.setState({
        selected: null
      });
    };

    _this.set = function (selected) {
      _this.setState({
        selected: selected
      });
    };

    _this.handleChange = function (event, value) {
      _this.setState({
        selected: value
      });

      if (typeof _this.props.action === 'function') {
        _this.props.action(event, value);
      }
    };

    _this.state = {
      selected: props.defaultSelected
    };
    return _this;
  }

  _createClass(NitroRadioGroup, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Check that only one radio is checked on mount
      var cnt = 0;

      _react2.default.Children.forEach(this.props.children, function (option) {
        if (typeof option.props.checked !== 'undefined' && option.props.checked) {
          cnt += 1;
        }
      }, this);

      if (cnt > 1) {
        console.warn('Multiple radio buttons are checked by default, please check');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var options = _react2.default.Children.map(this.props.children, function (option) {
        var _option$props = option.props,
            name = _option$props.name,
            value = _option$props.value,
            label = _option$props.label,
            action = _option$props.action,
            other = _objectWithoutProperties(_option$props, ['name', 'value', 'label', 'action']);

        return _react2.default.createElement(
          _styles.RadioInput,
          null,
          _react2.default.createElement(_nitroRadio2.default, _extends({}, other, {
            ref: option.props.value,
            name: _this2.props.name,
            key: option.props.value,
            value: option.props.value,
            label: option.props.label,
            action: _this2.handleChange,
            checked: option.props.value === _this2.state.selected
          }, _this2.props.radioProps))
        );
      }, this);

      return _react2.default.createElement(
        _styles.RadioGroup,
        null,
        options
      );
    }
  }]);

  return NitroRadioGroup;
}(_react.Component);

NitroRadioGroup.propTypes = {
  action: _propTypes2.default.func,
  children: _propTypes2.default.node,
  defaultSelected: _propTypes2.default.string,
  name: _propTypes2.default.string.isRequired,
  radioProps: _propTypes2.default.object
};

NitroRadioGroup.defaultProps = {
  name: 'radio-group'
};

exports.default = NitroRadioGroup;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-radio-group/NitroRadioGroup.js
// module id = 3027
// module chunks = 4